import { Routes } from '@angular/router';

/** Production and staging builds ship no dev routes. */
export const DEV_ROUTES: Routes = [];
